var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _vm.dashboardLoadingFailed
      ? _c(
          "div",
          { staticClass: "m-2 alert alert-danger", attrs: { role: "alert" } },
          [_vm._v("\n    Failed to load dashboard\n  ")]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticStyle: { width: "100vw", height: "100vh" },
        attrs: { "data-dashboard-theme-mode": _vm.theme }
      },
      [
        _c(_vm.getComponentName(_vm.rootConfiguration.type), {
          ref: "element",
          tag: "Component",
          attrs: { elementPath: 0, configuration: _vm.rootConfiguration }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }